/**
 * 需要上报的业务异常基础类
 * 业务需要自己继承该异常，重写business
 *  class BaseException extends CustomException{
        constructor(err, name, message, option = { noReportElk: false, business: 'Scanpay' }) {
            super(err, name, message, option);
        }
    }
 */
export class CustomException extends Error {
  override stack = '';
  data: any = null;
  // message为代码中的关键字，后续可以搜索到代码对应的逻辑
  constructor(err: any, name: string, message?: string) {
    super();
    // name作为自定义异常的key,用户搜索
    this.name = name || 'BaseException';
    // 自定义异常，更多的附加信息
    this.message = `CustomException_${message || 'default Message'}`;
    // 当有系统报出的错误，是有stack的，就用系统报错的stack。如果没有，那可能是来自某个reject,那这个就用当前的堆栈
    this.stack = err && err.stack ? err.stack : '';

    // err有可能是string,也可能是error对象，也可能是http请求的reject。
    // 当如果是http请求的reject，可能外层处理，需要用到data，比如密码校验失败，展示弹窗时候，需要这里很多数据
    // 这里是为了能够把reject的数据，携带出去，携带到最上层的自定义错误
    const data = err && err.data ? err.data : err;
    if (!(data instanceof Error) && typeof data === 'object') {
      this.data = data;
    } else {
      // 有些地方直接reject一个string,又不是JsError，这种情况也需要记录下来
      if (typeof data === 'string') {
        this.data = { defaultMsg: data };
      } else {
        this.data = null;
      }
    }
  }

  /**
   * 获取数据
   * @return {[type]} [description]
   */
  getData() {
    return {
      name: this.name,
      message: this.message,
      stack: this.stack,
      data: this.data,
    };
  }
}
